import script from "./TransportInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransportInfo.vue?vue&type=script&setup=true&lang=ts"

import "./TransportInfo.vue?vue&type=style&index=0&id=6d570cbc&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d570cbc"]])

export default __exports__